import clsx from "clsx";
import RadioInput from "../RadioInput/RadioInput";
import CheckBox from "../CheckBox/CheckBox";
import { useEffect, useState } from "react";
import { find } from "lodash";

export type CheckBoxGridType = {
  onChange: (selected: any[]) => void;
  selected: any[];
  disabled?: boolean;
  options: Array<any>;
  columns: number;
};

const CheckBoxGrid: React.FC<CheckBoxGridType> = ({
  disabled = false,
  options,
  columns = 2,
  selected,
  onChange,
}) => {
  const [selectedOptions, setSelectedOptions] = useState<any[]>(selected || []);

  useEffect(() => {
    onChange(selectedOptions);
  }, [selectedOptions]);

  return (
    <div
      className={clsx([
        "grid",
        "gap-2",
        "w-full",
        `grid-cols-${columns}`,
        {
          "pointer-events-none": disabled,
        },
      ])}
    >
      {options?.map?.(({ label, description, value }) => {
        return (
          <CheckBox
            label={label}
            description={description}
            checked={find(selectedOptions, { value })}
            key={value}
            onChange={(isChecked: boolean) => {
              if (isChecked) {
                setSelectedOptions((prev: any) => [...prev, { value, label }]);
              } else {
                setSelectedOptions((prev: any) =>
                  prev.filter?.(
                    (selectedValue: any) => selectedValue?.value !== value
                  )
                );
              }
            }}
          />
        );
      })}
    </div>
  );
};

export default CheckBoxGrid;
